import { ThemeType } from '@app/api/models/Theme';
import styled, { CreateStyled } from '@emotion/styled';

type Style<T = void> = CreateStyled<{ colors: ThemeType['colors']; globalCss: ThemeType['globalCss'] }> & T;
const ThemedStyled = styled as Style;
export default ThemedStyled;
